import useSWR, { KeyedMutator } from 'swr';

import { useApplicationConfig } from '~/data/applicationConfig';
import { ProposalsConfigApiClient } from '~/services/Http';
import {
  IProposalTrackingListResultDto,
  ProposalTrackingListResultDto,
  Statuses,
} from '~/services/Http/client.iam.generated';

import { ProposalProps, ProposalStatus, ProposalType } from '.';

export type ProposalsPropsList = Omit<
  IProposalTrackingListResultDto,
  'data'
> & {
  proposals: ProposalProps[];
};
const processProposalsData = (
  proposalList?: ProposalTrackingListResultDto,
): ProposalsPropsList => {
  if (!!proposalList) {
    const { data, ...restData } = proposalList;
    const proposals: ProposalProps[] =
      (data as unknown as ProposalProps[]) || [];

    return {
      proposals,
      ...restData,
    };
  }
  return {
    proposals: [],
  };
};

export type GetProposalsProps = {
  proposalId?: string;
  proposalType?: ProposalType;
  targetId?: number;
  statuses?: ProposalStatus[];
};

export type UseGetProposalsOutput<T> = {
  data: ProposalsPropsList;
  mutate: KeyedMutator<T>;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  error: any;
  isLoading: boolean;
};

export const useGetProposals = ({
  proposalId,
  proposalType,
  targetId,
  statuses,
}: GetProposalsProps): UseGetProposalsOutput<ProposalTrackingListResultDto> => {
  const { applicationConfig, hasData } = useApplicationConfig();
  const workflowsEngineEnabled = hasData
    ? applicationConfig.fComConfig.miscellaneousConfig
        .fComEnableNewWorkflowsEngine
    : false;

  const { data, isLoading, error, mutate } = useSWR(
    workflowsEngineEnabled
      ? ['proposals', proposalId, proposalType, targetId, statuses]
      : null,
    () =>
      ProposalsConfigApiClient.getProposals(
        proposalId,
        proposalType,
        targetId,
        statuses as Statuses[] | undefined,
      ),
  );
  return {
    data: processProposalsData(data),
    isLoading,
    error,
    mutate,
  };
};
